module.exports = __webpack_public_path__ + "img/P539205805.1ba7ece4.jpg";